export default __webpack_public_path__ + "static/media/Upload_Button.cb611371.svg";